import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DeliveryStatus } from 'src/app/shared/enums';
import { OrderConfirmation } from 'src/app/shared/models/order-confirmation.model';

@Component({
  selector: 'app-order-row',
  templateUrl: './order-row.component.html',
  styleUrls: ['./order-row.component.scss']
})
export class OrderRowComponent {

  translatePath = 'home.receiver.dashboard.order-row.';
  deliveryStatusEnum = DeliveryStatus;
  @Input() order: OrderConfirmation;
  constructor(
    private router: Router
  ) { }



  goToTrack(deliveryId: string) {
    this.router.navigate(['public', 'tracking', deliveryId]);
  }
}
